import React from 'react';
import { useDispatch } from 'react-redux';
import { removeCartItem, addProduct, reduceCartItem } from './../../../redux/Cart/cart.actions';

const Item = (product) => {
  const dispatch = useDispatch();
  const {
    productName,
    productThumbnail,
    productPrice,
    quantity,
    documentID
  } = product;

  const handleRemoveCartItem = (documentID) => {
    dispatch(
      removeCartItem({
        documentID
      })
    );
  }

  const handleAddProduct = (product) => {
    dispatch(
      addProduct(product)
    )
  }

  const handleReduceItem = (product) => {
    dispatch(
      reduceCartItem(product)
    );
  }

  return (
    <table className="cartItem" border="0" cellSpacing="0" cellPadding="10">
      <tbody>
        <tr>
          <td>
            <img src={productThumbnail} alt={productName} />
          </td>
          <td className='desc'>
            {productName}
          </td>
          <td className="quantityControlCell">
            <span
              className="cartBtn quantityBtn"
              onClick={() => handleReduceItem(product)}
              aria-label="Decrease quantity"
              role="button"
            >
              <i className="fa fa-minus" />
            </span>

            <span className="quantityValue">{quantity}</span>

            <span
              className="cartBtn quantityBtn"
              onClick={() => handleAddProduct(product)}
              aria-label="Increase quantity"
              role="button"
            >
              <i className="fa fa-plus" />
            </span>
          </td>
          <td>
            £{productPrice}
          </td>
          <td align="center">
            {/* <span className="cartBtn remove" onClick={() => handleRemoveCartItem(documentID)}>
              X
            </span> */}
            <span className="cartBtn remove" onClick={() => handleRemoveCartItem(documentID)}>
              <i className="fa fa-trash" aria-hidden="true"></i>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  );
}

export default Item;
